module.exports = __webpack_public_path__ + "static/media/image5.b7d353ec.svg";